module.exports = __webpack_public_path__ + "img/coop2.f4a4e808.png";